export default __webpack_public_path__ + "57aba2789409ae0a6f227a374deead4c.gif";